import React from 'react'
import ResponsivePopover from '@/components/molecules/ResponsivePopover/ResponsivePopover'
import { InfoCircle } from 'react-bootstrap-icons'

const HowWeSortResultsTooltip = () => {
  return (
    <ResponsivePopover
      header="How we sort our results"
      description="Centers are ranked according to their verified status, relevancy, popularity, specializations and reviews. Additionally, compensation from advertisers is also a factor taken into consideration when determining the order of similar centers."
      buttonText="Learn More"
      buttonLink="/claim-verify-process/"
      buttonType="tertiary"
    >
      <div className="flex cursor-pointer items-center text-xs font-semibold text-gray-800">
        How we sort our results <InfoCircle className="ml-1.5 text-gray-900" />
      </div>
    </ResponsivePopover>
  )
}

export default HowWeSortResultsTooltip
